module.exports = "https://bin.bnbstatic.com/_next/static/images/banner-bg-7ee2ffee4670408b3a6631b2f713f8a5.jpg";